import React, { Component } from 'react'
import i18n from '../i18n.json'
import Sign from '../containers/Sign'

class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      userLocation: null
    }
  }

  componentWillMount() {
    this.setState({
      loading: true
    })
    this.props.authenticateUser()
    .then(() => {
      this.setState({
        loading: false
      })
      this.props.getPurchases()
    })
    .catch((error) => {
      this.setState({
        loading: false
      })
    })
  }

  componentDidMount() {
    if (this.state.userLocation) return
    let url = 'https://freegeoip.net/json/'
    fetch(url)
    .then((response) => response.json())
    .then((responseJson) => {
      let { country_code } = responseJson
      if (country_code) {
        if (country_code === 'BR')
          this.props.updateLanguage('pt')
        else
          this.props.updateLanguage('en')
        this.setState({
          userLocation: country_code
        })
      }
    })
    .catch((error) => {
      // console.error(error)
    })
  }

  renderNav() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
      <div className="nav">
        <ul>
          <li className="left-corner">
            <a id="automagic-logo" href="/">
              automagic<br />.design
            </a>
          </li>
          <li>
              <a href="/">
                <div className="padding-bottom">
                  <h2><i className="fa fa-plus"></i></h2>
                  { i18n[selectedLanguage]['dashboard-menu-new-logo'] }
                </div>
              </a>
          </li>
          <li className="nav-large right-corner">
            <a href="/" onClick={ this.props.signOut.bind(this) }>
              <div className="padding-bottom">
                  <h2><i className="fa fa-sign-out"></i></h2>
                  { i18n[selectedLanguage]['menu-signout'] }</div>

            </a>
          </li>
          <li className="nav-small right-corner">
            <a href="/" onClick={ this.props.signOut.bind(this) }>
              <h2><i className="fa fa-sign-out"></i></h2>
            </a>
          </li>

        </ul>

      </div>
    )
  }

  renderPurchasedProducts() {
    let { purchases } = this.props
    let { purchasedProducts } = purchases
    if (!purchasedProducts) return null
    if (purchasedProducts.length <= 0) return null

    return purchasedProducts.map((product) => {
      let { svg, uid } = product
      if (!svg) return null
      let uriSVG = null
      if (svg.light) uriSVG = "data:image/svg+xml;utf8," + encodeURIComponent(svg.light)
      else uriSVG = "data:image/svg+xml;utf8," + encodeURIComponent(svg)
      let background = "#fff"
      if (product.elements) {
        if (product.elements.colorPalette) {
          if (product.elements.colorPalette.colorBackground) {
            background = product.elements.colorPalette.colorBackground
          }
        }
      }

      //let uriSVGDark = "data:image/svg+xml;utf8," + encodeURIComponent(svg.dark)
      return (
         <li key={"preview-"+uid} >
           <a href={ '/guideline/' + uid }>
             <img src={ uriSVG } alt={ "Logo Preview #" + uid} style={{width:"50%",padding:"10%","backgroundColor":background}} />
           </a>
           { /* svg.dark
             ?
             <a href={ '/guideline/' + uid }>
               <img src={ uriSVGDark } alt={ "Logo Preview #" + uid} />
             </a>
             : null */
           }
         </li>
      )
    })
  }

  renderContent() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    let userName = null
    let { authenticatedUser, purchases } = this.props
    if (authenticatedUser) userName = authenticatedUser.name
    let { purchasedProducts } = purchases
    let numberPurchases = 0
    if (!purchasedProducts) numberPurchases = 0
    else numberPurchases = purchasedProducts.length

    return (
      <div className="fullpage">
        <div className="flex-row">

          <div className="page-description" id="dashboard-title">
            {  userName
              ?
                <h1>{i18n[selectedLanguage]['step-dashboard-title'] + ` ${userName},`}</h1>
              :
                <h1>{ i18n[selectedLanguage]['step-dashboard-title'] }</h1>
            }
            { (numberPurchases > 0)
              ?
                <p> { i18n[selectedLanguage]['step-dashboard-description'] } </p>
              :
                <p> { i18n[selectedLanguage]['step-dashboard-nopurchase'] } </p>
            }
          </div>

          <div className="page-content" id="dashboard">
            <ul>
              { this.renderPurchasedProducts() }
            </ul>
          </div>

        </div>
      </div>
    )
  }

  renderModal() {
    let { purchases, authenticatedUser } = this.props
    let { purchasedProducts } = purchases
    if (authenticatedUser) return null
    if (this.state.loading) {
      return (
        <div className="modal">
          <div className="modal-box">
            Loading...
          </div>
        </div>
      )
    }
    if (purchasedProducts.length > 0) {
      let { loading, error } = purchases
      if (loading) {
        return (
          <div className="modal">
            <div className="modal-box">
              Loading...
            </div>
          </div>
        )
      }
      if (error) {
        if (error.status && (error.status === 401)) {
          return (
            <div className="modal">
              <Sign attemptedAction="getPurchases" />
            </div>
          )
        }
        // TODO: Threat other kinds of errors
      }
      // No error, no loading, OK then, you can pass
      return null
    }
    // Default is show modal to sign in/up
    return (
      <div className="modal">
        <Sign attemptedAction="getPurchases" />
      </div>
    )
  }

  renderBottom() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    return (
        <div>
         <div className="bottom bottom-left">
          <a href="/about">{ i18n[selectedLanguage]['bottom-about'] }</a> |
          <a href="/pricing"> { i18n[selectedLanguage]['bottom-pricing'] }</a> |
          <a href="mailto:contact@automagic.design"> { i18n[selectedLanguage]['bottom-contact'] }</a> |
          <a href="/tos"> { i18n[selectedLanguage]['bottom-tos'] }</a> |
          <a href="/privacy"> { i18n[selectedLanguage]['bottom-privacy'] }</a>
         </div>
         <div className="bottom bottom-right">
          <a className="language-selector" href="/en" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('en') } }> EN</a> |
          <a className="language-selector" href="/pt" onClick={ (evt) => { evt.preventDefault(); this.props.updateLanguage('pt') } }> PT-BR</a>
         </div>
        </div>
    )
  }

  render() {
    return (
      <div>
        { this.renderModal() }

        { this.renderNav() }

        { this.renderContent() }

        { this.renderBottom() }
      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/components/Dashboard.js